import React, {FC, useEffect} from 'react';
import {WithStyles, withStyles} from "@material-ui/core";
import { styles } from "./styles";
import {connect} from "react-redux";

interface IProps extends WithStyles<typeof styles> {
  history?: any;
  isMaintenance?: any;
}

const Maintenance : FC<IProps> = ({ classes, history, isMaintenance }) => {

  useEffect(() => {
    if(!isMaintenance) {
      const residentAccessUrl = localStorage.getItem('ResidentAccessUrl');
      history.push(residentAccessUrl);
    }
  }, [isMaintenance]);

  return (
    <div className={classes.maintenance}>
      <p className={classes.maintenanceMessage}>ただいまメンテナンス中です</p>
      <p>
        ご利用の皆様にはご迷惑をおかけし、大変申し訳ございません。<br />
        ただいまサービス向上のため、システムメンテナンスを実施しております。<br />
        メンテナンス終了までしばらくお待ちください。<br />
      </p>
      <p>
        ご不便をおかけいたしますがよろしくお願い申し上げます。
      </p>
    </div>
  );
};

export const mapStateToProps = state => ({
  isMaintenance: state.maintenance.isMaintenance,
});

export default connect(
  mapStateToProps
)(withStyles(styles)(Maintenance));

